import { KeyValue } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { WidgetPanelCounts } from 'src/app/interfaces/widget-panel-counts';
import { ToastService } from 'src/app/services/toast.service';

import { TitleContentWidgetComponent } from '../title-content-widget/title-content-widget.component';

@Component({
  selector: 'app-display-counts-widget',
  templateUrl: './display-counts-widget.component.html',
  styleUrls: ['./display-counts-widget.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DisplayCountsWidgetComponent
  extends TitleContentWidgetComponent
  implements OnInit
{
  constructor(
    private ToastService: ToastService,
    private elementRefDisplayCounts: ElementRef,
    private Router: Router
  ) {
    super(elementRefDisplayCounts);
  }

  @Input() widgetPanelCounts!: WidgetPanelCounts;

  override ngOnInit(): void {
    super.ngOnInit();
    if (!this.widgetPanelCounts) {
      throw this.ToastService.addErrorToast(
        'Error',
        'Missing widget panel from display counts widget'
      );
    }
  }

  isObjectWithCount(value: any): value is { count: number; query: {} } {
    return value && typeof value === 'object' && 'count' in value;
  }

  navigateToCountGrid(displayCount: { [key: string]: any }) {
    const { query, route, gridQuery, FilterModel } = displayCount['value'];

    if (query && !route) {
      return this.Router.navigate(['admin/run-vive'], {
        state: { query, displayCount }
      });
    }

    if (route && FilterModel) {
      return this.Router.navigateByUrl(route, {
        state: { title: displayCount['key'], FilterModel }
      });
    }

    if (route && query) {
      return this.Router.navigateByUrl(route, {
        state: { query, title: displayCount['key'] }
      });
    }

    if (route) {
      return this.Router.navigateByUrl(route);
    }

    return;
  }
}
